export class LocalStorage {
    private prefix: string = '';

    setPrefix(prefix: string) {
        this.prefix = prefix;
    }

    private key(key: string) {
        if (this.prefix) {
            return this.prefix + '-' + key;
        }
        return key;
    }

    private getItem(key: string, defaultVal?: string) {
        return window.localStorage.getItem(this.key(key)) || defaultVal;
    }

    private setItem(key: string, val: string) {
        window.localStorage.setItem(this.key(key), val);
    }

    getString(key: string, defVal?: string) {
        return this.getItem(key, defVal);
    }

    setString(key: string, val: string) {
        this.setItem(key, val);
    }

    getInt(key: string, defVal: number = 0) {
        let ret = parseInt(this.getItem(key) as string);
        return ret || defVal;
    }

    setInt(key: string, val: number) {
        this.setItem(key, val + '');
    }

    getBoolean(key: string, defVal: boolean = false) {
        let ret = this.getItem(key);
        if (ret == 'true') {
            return true;
        } else if (ret == 'false') {
            return false;
        } else if (ret == '0') {
            return false;
        } else if (ret == '1') {
            return true;
        }
        return defVal;
    }

    setBoolean(key: string, val: boolean) {
        this.setItem(key, val ? 'true' : 'false');
    }
}

var localStorage: LocalStorage = new LocalStorage();

export default localStorage;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/LocalStorage.ts